import MobilePlug from './other'

export default MobilePlug
